import {StateHandler} from "../../../../core/utils/StateHandler";

export class XWayStateLevel extends StateHandler {

    public static LEVEL_1: number = 0;
    public static LEVEL_2: number = 1;
    public static LEVEL_3: number = 2;

    protected static ValueLevels: number[] = [800, 2200, 4600];
    protected static TextureLevels: string[] = ["Header_A", "Header_B", "Header_C"];
    protected static SpineLevels: string[] = ["Header_Loop_A", "Header_Loop_B", "Header_Loop_C"];

    public get lastLvl(): number {
        return XWayStateLevel.ValueLevels[this.value - 1] ? XWayStateLevel.ValueLevels[this.value - 1] : 0;
    }

    public get nextLvl(): number {
        return XWayStateLevel.ValueLevels[this.value + 1] ? XWayStateLevel.ValueLevels[this.value + 1] : 100000000000000;
    }

    public get valueLvl(): number {
        return XWayStateLevel.ValueLevels[this.value]
    }

    public get TextureLvl(): string {
        return XWayStateLevel.TextureLevels[this.value]
    }

    public get SpineLvl(): string {
        return XWayStateLevel.SpineLevels[this.value]
    }

    public set(val: number): boolean {
        if (val > XWayStateLevel.LEVEL_3 || val < XWayStateLevel.LEVEL_1) return false;
        super.set(val);
        return true;
    }
}